<template>
  <div>
    <div class="xq_top">
      <img class="img" @click="xqesc" src="../../static/images/esc.png" />
      <p @click="xqesc">{{pickda[pickxb].fh}}</p>
      <span>{{pickda[pickxb].ddxq}}</span>
    </div>


    <div class="goodsBigDiv" style="width:100%;" ref="piediv">
      <!--v-if="feilist[fei_xb].TypeID==item.TypeID"-->
      <div>
        <div class="goodsList" v-for="(item,index2) in goodslist" v-if="item.IsMenu" @click="addcur(index2)" style="height: 2rem;">
          <div class="goodsRight">
            <img  @error="imageLoad(index,index2)" :src="$lujin+'/Data/'+ShopID+'/GoodsPic/'+item.GoodsID+'.jpg'"/>
            <span class="span" v-if="item.IsEmpty">Sellout</span>
          </div>
          <div class="goodsLift">
            <div v-if="WXLangGoodsxb==0" class="goodsName">{{item.Goods}}</div>
            <div v-if="WXLangGoodsxb==1" class="goodsName">{{item.TwoGoods}}</div>
            <div v-if="WXLangGoodsxb==2" class="goodsName">{{item.ThreeGoods}}</div>
            <div class="goodsBottom">
              <div class="goodsPrice" v-if="item.IsBuffetGoods&&IsBuffet">0</div>
              <div class="goodsPrice" v-else>{{MoneySymbol}}{{item.MessyPrice.toFixed(2)}}</div>
            </div>
            <!--<div class="lei">
              <span>{{pickda[pickxb].lb}}:</span>
              <span v-if="pickindex==0" style="color:red">{{item.TypeName}}</span>
              <span v-if="pickindex==1" style="color:red" >{{item.TwoTypeName}}</span>
              <span v-if="pickindex==2"  style="color:red">{{item.ThreeTypeName}}</span>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import '../../static/css/Default.css'
  export default {
    data() {
      return {
        ShopID: 0,
        DeskID: 0,
        IsBuffet:0,
        BuffetTypeID:0,
        Numberpoints:0,
        pickxb:2,
        Context: "",
        pickindex:0,
        WXLangGoodsxb:0,
        goodslist:[],
        MoneySymbol:'',
        pickda:[
          {fh:"返回",ddxq:"搜索结果",lb:"所在类别"},
          {fh:"返回",ddxq:"搜索結果",lb:"所在类别"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"إرجاع",ddxq:"نتائج البحث",lb:"حيث الفئة"},
          {fh:"ដកថយ",ddxq:"លទ្ធផលស្វែងរក",lb:"ប្រភេទ"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"Terug",ddxq:"Zoekresultaten",lb:"categorie"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"Indietro",ddxq:"risultati della ricerca"},
          {fh:"戻り",ddxq:"検索結果",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"wrócić",ddxq:"Wyniki wyszukiwania"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"return",ddxq:"The search results",lb:"Location category"},
          {fh:"qayıtmaq",ddxq:"Axtarış Nəticələri",lb:"Kateqoriya"},
          {fh:"ပြန်",ddxq:"ရှာဖွေမှုရလဒ်",lb:"အမျိုးအစား"},
          {fh:"Geri Dön",ddxq:"Arama sonuçları",lb:"Kategori"},
          {fh:"буцах",ddxq:"Хайлтын үр дүн",lb:"Ангилал"},
        ]
      }
    },
    mounted() {
      this.ShopID = this.$route.query.Shopid;
      this.DeskID = this.$route.query.id;
      this.Context = this.$route.query.context;
      var that=this
      console.log(localStorage.getItem(this.$route.query.Shopid+'pickxb'))
      if (localStorage.getItem(this.$route.query.Shopid+'pickxb') != null) //判断语音下标
        this.pickxb = localStorage.getItem(this.$route.query.Shopid+'pickxb')
      if(localStorage.getItem(this.$route.query.Shopid+'pickindex'))//判断语音下标
        this.pickindex=localStorage.getItem(this.$route.query.Shopid+'pickindex')
      if(localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb'))//判断语音下标
        this.WXLangGoodsxb=localStorage.getItem(this.$route.query.Shopid+'WXLangGoodsxb')
      var _this = this;
      this.axios.post(this.$lujin+"/api/Default/Parameter?ShopID="+this.$route.query.Shopid).then((res)=>{
        this.MoneySymbol=res.data.data[0].MoneySymbol
      })
      const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date();
      const Week = weekDays[today.getDay()];
      const WeekQua = today.getDay()==0?7:today.getDay()
      let hh = new Date().getHours()
      let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      var time=hh+":"+mf+":"+ss
      if(this.$route.query.id!="Food"){
        this.axios.post(that.$lujin+"/api/default/TDeskzt?ShopID="+this.$route.query.Shopid+"&DeskID="+this.$route.query.id)
        .then((res)=>{
          console.log(res)
		  that.IsBuffet=res.data[0].IsBuffet
		  that.IsBuffetzt=res.data[0].IsBuffet
		  that.BuffetTypeID=res.data[0].BuffetTypeID
		  that.Numberpoints=res.data[0].Numberpoints
          that.axios.get(that.$lujin+"/api/default/TDeskMin?ShopID="+that.$route.query.Shopid+"&DeskID="+that.$route.query.id+"&Time="+parseInt(Date.now()/1000))
          .then((res)=>{
            console.log(res)
            console.log(res.data==0)
            if(res.data==0)that.IsBuffet=0
            this.axios.post(this.$lujin+'/api/Default/Shousuo?nr='+this.$route.query.context+"&ShopID="+this.$route.query.Shopid+"&Week="+Week+"&Time="+time+"&WeekQua="+WeekQua).then((res)=>{
              console.log(res)
              var goodslist=JSON.parse(res.data)
              if(JSON.parse(res.data).length>0){
                this.axios.get(this.$lujin+'/api/Default/MenuType?ShopID='+this.$route.query.Shopid).then((res)=>{
                  console.log(JSON.parse(res.data).Table)
                  var MenuType=JSON.parse(res.data).Table;
                  if(that.IsBuffet){
                    var jsonsz=[]
                    for(var j in goodslist){
                      if(goodslist[j]==null)continue;
                      var busz=goodslist[j].BuffetTypeID.split(',')
                      var busz2=goodslist[j].DisplayBuffet.split(',')
                      for(var ppp in busz){
                      	if(busz[ppp]==that.BuffetTypeID){
                          goodslist[j].IsBuffetGoods=1
                      	}
                      }
                      for(var ppp in busz2){
                      	if(busz2[ppp]==that.BuffetTypeID){
                          jsonsz.push(goodslist[j])
                      	}
                      }
                    }
                    goodslist=jsonsz
                  }
                  for(var i in goodslist){
                    for(var j in MenuType){
                      if(goodslist[i].TypeID==MenuType[j].TypeID){
                        goodslist[i].TypeName=MenuType[j].TypeName
                        goodslist[i].TwoTypeName=MenuType[j].TwoTypeName
                        goodslist[i].ThreeTypeName=MenuType[j].ThreeTypeName
                      }
                    }
                  }
                  console.log(goodslist)
                  this.goodslist=goodslist
                })
              }
            })
          })
        })
      }          //获取商品列表


    },
    methods: {
      imageLoad(i,j){
        console.log(this.$refs.piediv.children[0].children[j].children[0].children[0])
        this.$refs.piediv.children[0].children[j].children[0].children[0].style="display:none;"
      },
      xqesc() {
        this.$router.go(-1);
      },
      addcur(xb){
        var that=this
        console.log(JSON.parse(localStorage.getItem("shuju")))
        var listsz=JSON.parse(localStorage.getItem("shuju"))
        var tm=-1,tg=-1
        for(var i in listsz){
          for(var j in listsz[i].sz){
            if(this.goodslist[xb].GoodsID==listsz[i].sz[j].GoodsID){
              console.log(i,j)
              tm=i
              tg=j
            }
          }
        }
        console.log(1)
        if(tm==-1){
          return
        }
        console.log(1)
        var obj={
          zt:true,
          xb_i:tm,
          xb_j:tg,
          sl:1,
          bz:"",
          id:this.goodslist[xb].GoodsID,
          momey:(this.goodslist[xb].IsBuffetGoods&&this.IsBuffet)?0:this.goodslist[xb].MessyPrice,
          Goods:this.goodslist[xb].Goods,
          TwoGoods:this.goodslist[xb].TwoGoods,
          ThreeGoods:this.goodslist[xb].ThreeGoods,
          IsBuffetGoods:this.goodslist[xb].IsBuffetGoods,
          zf:"",
          zf:"0,0,0,0,0,0,0,0",
          FromID:0,
          IsChild:0,
          isRoot:0,
          addmomey:0,
          getTime:(new Date()).getTime()
        }
        console.log(obj)
        var sz=[]
        if(localStorage.getItem(this.ShopID+'list')){
          sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
          sz.push(obj)
        }else{
          sz.push(obj)
        }
        localStorage.setItem(this.ShopID+'list', JSON.stringify(sz));
        that.xqesc()
        return
        /*var that=this
        this.axios.get(this.$lujin+'/api/Default/ObtainGoods?GoodsID='+this.goodslist[xb].GoodsID+"&ShopID="+this.$route.query.Shopid).then((res)=>{
          console.log(res)
          if(res.data.state){
            var obj={
              zt:true,
              xb_i:res.data.tm,
              xb_j:res.data.tg,
              sl:1,
              bz:"",
              id:this.goodslist[xb].GoodsID,
              momey:this.goodslist[xb].IsBuffetGoods?0:this.goodslist[xb].MessyPrice,
              Goods:this.goodslist[xb].Goods,
              TwoGoods:this.goodslist[xb].TwoGoods,
              ThreeGoods:this.goodslist[xb].ThreeGoods,
              IsBuffetGoods:this.goodslist[xb].IsBuffetGoods,
              zf:"",
              zf:"0,0,0,0"
            }
            console.log(obj)
            var sz=[]
            if(localStorage.getItem(this.ShopID+'list')){
              sz=JSON.parse(localStorage.getItem(this.ShopID+'list'))
              sz.push(obj)
            }else{
              sz.push(obj)
            }
            localStorage.setItem(this.ShopID+'list', JSON.stringify(sz));
            that.xqesc()
          }
        })*/
      }
    }
  }
</script>

<style scoped>
  .goodsBigDiv .goodsList .goodsRight{width: 40%;}
  .goodsBigDiv .goodsList .goodsLift{width: 60%;}
  .goodsBigDiv{margin-top:1rem;}
  .lei span{font-size: .28rem;}
  .lei{line-height:.48rem;text-align: left;}
</style>



// WEBPACK FOOTER //
// src/components/ss.vue